import { Line as KonvaLine } from "react-konva"
import { useAppSelector } from "../../../../store/hooks"
import { Transform } from "../../../../geometry/transformation"
import { hitStrokeCorrection } from "../../util/strokeCorrection"
import { useMemo } from "react"
import { RootState } from "../../../../store/store"

const BaseLine = (({ setRef, shapeProps, onClick, interaction }: BaseShapeProps<LineShape>) => {
    const lineTypes = useAppSelector((state: RootState) => state.tool.lineTypes)
    const scale = useAppSelector((state: RootState) => state.interface.viewport.scale)
    // const lineRef = useRef<Konva.Line>(null);
    // const dispatch = useAppDispatch();
    const trafo = new Transform(shapeProps.transformation);

    const trafoedPoints = shapeProps.points.map(coordiante => {
        const c = trafo.point2d(coordiante);
        return { ...coordiante, x: c.x, y: c.y }
    });
    const correctedHitStrokeWidth = useMemo(() => hitStrokeCorrection(shapeProps.hitStrokeWidth, shapeProps.strokeWidth, scale), [shapeProps, scale]);
    // useEffect(() => {
    //     console.log(lineRef.current?.id());

    //     if (setRef) setRef(lineRef)
    //     const size = lineRef.current?.size();
    //     const payload = size ? { size: size, id: shapeProps.id } : undefined;
    //     // dispatch(modelUpdateBoundingbox(payload))
    // }, [lineRef, setRef])
    // console.log("cucc");


    const newProps = /* useMemo(() => {


        return  */{
        ...shapeProps,
        dash: lineTypes.find((a, i) => i === shapeProps.dashID)?.dash,
        id: `${shapeProps.id}`,
        points: trafoedPoints.flatMap(p => [p.x, -p.y]),
        draggable: shapeProps.draggable ? shapeProps.draggable : true,
        hitStrokeWidth: correctedHitStrokeWidth,
        closed:
            shapeProps.points.length > 5 &&
            shapeProps.points[0] === shapeProps.points[shapeProps.points.length - 2] &&
            shapeProps.points[1] === shapeProps.points[shapeProps.points.length - 1],
    }
    /*} , [shapeProps, correctedHitStrokeWidth, lineTypes, trafoedPoints]) */


    // useEffect(() => {
    //     console.log("box", lineRef.current?.width(), lineRef.current?.height());
    // })
    // const Line = useMemo(() => {
    //     console.log("useMemoNewProps", newProps.points);
    //     return (
    //         <><KonvaLine
    //             ref={lineRef}
    //             key={shapeProps.id}
    //             dragBoundFunc={function (this, pos) {
    //                 return this._lastPos || this.absolutePosition()
    //             }}
    //             onDragStart={interaction?.handleDragStart}
    //             onDragMove={interaction?.handleDragMove}
    //             onDragEnd={interaction?.handleDragEnd}
    //             onClick={onClick}
    //             {...newProps} />
    //             {/* <Circle x={newProps.transformation[3][0]} y={-newProps.transformation[3][1]} radius={25} fill="green" />
    //             <Circle x={newProps.transformation[3][0]+ newProps.width} y={-newProps.transformation[3][1]+newProps.height} radius={25} fill="green" /> */}
    //         </>
    //     )
    // }, [shapeProps.id, interaction, onClick, newProps.points])
    return (
        <KonvaLine
            ref={setRef}
            key={shapeProps.id}
            dragBoundFunc={function (this, pos) {
                return this._lastPos || this.absolutePosition();
            }}
            onDragStart={interaction?.handleDragStart}
            onDragMove={interaction?.handleDragMove}
            onDragEnd={interaction?.handleDragEnd}
            onClick={onClick}
            {...newProps}
        />
        // Line
    )
})
const createLineBase = (shapeProps: GeometricShape) => {
    return <BaseLine shapeProps={shapeProps as LineShape} ></BaseLine>
}

export { createLineBase }
export default BaseLine;